<template>
	<div class="container-fluid">
		<contact-toolbar v-if="$store.contact" :heading="$store.contact.name" :sub-heading="$store.contact.address"></contact-toolbar>

		<vue-form v-on:submit="saveDetails" 
			:working="statusWorking" 
			:save-button-fixed="false" 
			:no-top-button="true"
			:readonly="readonly" 
			size="md">

			<div v-if="ownerContact">
				<router-link :to="'/contact/'+ownerContact.slug+'/summary'">
					<i class="fa fa-arrow-left"></i>
					{{ownerContact.name}}
				</router-link>
			</div>

			<h2 v-if="$route.params.id == 'new' && $route.params.parent_slug && parentContact">Create New Sub-Contact for {{ parentContact.name }}</h2>
			<h2 v-else-if="$route.params.id == 'new'">Create New Contact</h2>

			<div style="clear: both;"></div>
			<alert v-if="$store.contact.link_accepted == 0 && $store.contact.link_denied == 0 && hasAccountLink($store.contact) && !hasCustomerAccountLink($store.contact)"
				class="alert-info"
				:visible="true"
				icon="fa-link"
				message="A matching Tradetraks account has been found, would you like to link it to this contact?">

				<div class="mt-2 float-right">
					<button class="btn btn-success" v-on:click="linkAccount(true)">
						<i class="fa fa-check"></i>
						Yes, Link Account
					</button>

					<button class="btn btn-light" v-on:click="linkAccount(false)">
						<i class="fa fa-times"></i>
						No
					</button>
				</div>
			</alert>
			<p v-else-if="(hasAccountLink($store.contact) && $store.contact.link_accepted == 1)" class="text-muted">
				This contact is linked to a {{$store.appName}} account so the contact details are linked.
				<a href="#" v-on:click.prevent="linkAccount(false)">Unlink account</a>
			</p>
			<p v-else-if="hasCustomerAccountLink($store.contact)" class="text-muted">
				The user belonging to this contact has accepted a link with your company.<br>
				Some details in this contact record may be locked from editing and extracted from their linked data.
			</p>

			<h3>Details</h3>

			<div style="clear: both;"></div>

			<field label="Type"
				col-class="col-sm-3 col-lg-3" 
				v-model="typeReadonly ? ($store.contact.UserLink && $store.contact.is_link_accepted? 0 : 1) : $store.contact.is_company"
				:params="{type: 'btn-group', buttons: [
					{value: '1',text:'Company'},{value: '0',text:'Individual'},
				]}" 
				:readonly="typeReadonly">
			</field>

			<field 
				:label="$store.contact.is_company == 1 ? 'Company Name' : 'Name'" 
				col-class="col-sm-3 col-lg-3" 
				v-model="nameReadonly ? contactNameValue($store.contact) : $store.contact.name" 
				:params="{required:true}" 
				:readonly="nameReadonly" 
				:invalid="$store.errorList.name">
			</field>

			<field label="Phone" 
				col-class="col-sm-3 col-lg-3" 
				v-model="phoneReadonly ? contactPhoneValue($store.contact) : $store.contact.phone"
				:readonly="phoneReadonly">
			</field>

			<field label="Email" col-class="col-sm-3 col-lg-3" v-model="emailReadonly ? contactEmailValue($store.contact) : $store.contact.email"  :readonly="emailReadonly"></field>

			<field label="Website" col-class="col-sm-3 col-lg-3" v-model="websiteReadonly ? contactWebsiteValue($store.contact) : $store.contact.website"  :readonly="websiteReadonly"></field>

			<address-manual-selector
				col-class="col-sm-3 col-lg-3"
				:suite="$store.contact.suite"
				:address="addressReadonly ? contactAddressValue($store.contact).address : $store.contact.address"
				:city="addressReadonly ? contactAddressValue($store.contact).city : $store.contact.city"
				:province="addressReadonly ? contactAddressValue($store.contact).province : $store.contact.province"
				:country="addressReadonly ? contactAddressValue($store.contact).country : $store.contact.country"
				:postal-code="addressReadonly ? contactAddressValue($store.contact).postal_code : $store.contact.postal_code"
				:readonly="addressReadonly"
				:invalid-list="$store.errorList"
				v-on:input="updateLocation">
			</address-manual-selector>

			<field label="Is a Customer"
				col-class="col-sm-3 col-lg-3"
				v-model="isCustomerReadonly ? contactIsCustomerValue($store.contact) : $store.contact.is_customer"
				:params="{type: 'boolean'}"
				:readonly="isCustomerReadonly">
			</field>

			<field label="Is a Supplier" 
				col-class="col-sm-3 col-lg-3" 
				v-model="$store.contact.is_supplier" 
				:params="{type: 'boolean'}" 
				:readonly="readonly">
			</field>

			<div v-if="$store.contact.is_company == 1">
				<field label="Company Type" 
					col-class="col-sm-3 col-lg-3" 
					v-model="$store.contact.company_type" 
					:params="{type:'select',options:companyTypeOptions}"
					:readonly="readonly">
				</field>

			</div>

			<div v-else-if="$store.contact.is_company == 0">

				<field label="Position" 
					col-class="col-sm-3 col-lg-3" 
					v-model="$store.contact.position"  
					:readonly="readonly">
				</field>

				<form-group label="Belongs to (company)" col-class="col-sm-3 col-lg-3">
					<div class="d-flex flex-wrap">
						<field style="flex-grow: 1;" :style="{marginRight: companies.find(comp => comp.id == $store.contact.contact_id) ? '10px' : 0}"
							v-model="$store.contact.contact_id" 
							:params="{type:'select',options:optionifiedCompanies}" 
							:readonly="readonly">
						</field>
						<div v-if="companies.find(comp => comp.id == $store.contact.contact_id)">
							<router-link class="btn btn-light" :to="'/contact/'+ownerContact.slug+'/sub-contacts'">Go to</router-link>
						</div>
					</div>
				</form-group>

			</div>

			<field label="Notes" 
				col-class="col-sm-3 col-lg-3"
				v-model="$store.contact.notes"
				:params="{type:'textarea'}"
				:readonly="readonly">
			</field>

			<field v-if="qboIsActive && $store.contact.qbo_id > 0"
				label="Currency"
				col-class="col-sm-3 col-lg-3"
				:params="{type: 'select',options: [
					'CAD','USD'
				]}"
				v-model="$store.contact.currency_code"
				:readonly="readonly">
			</field>

			<template v-if="$store.contact.is_customer == '1'">

				<field
					label="Customer is On-Hold"
					col-class="col-sm-3 col-lg-3"
					:params="{type: 'boolean'}"
					v-model="onHoldModal.isOnHold"
					v-on:change="onHoldModal.visible = true"
					:readonly="readonly">
				</field>

				<field
					v-if="$store.contact.customer_onhold == '1'"
					label="Customer On-Hold Reason"
					col-class="col-sm-3 col-lg-3"
					v-model="$store.contact.customer_onhold_reason"
					:params="{type:'textarea'}"
					:readonly="readonly">
				</field>

			</template>

			<template v-if="qboIsActive && $store.contact.qbo_id > 0">
				<field label="QBO Id"
					col-class="col-sm-3 col-lg-3"
					:params="{type:'static'}"
					v-model="$store.contact.qbo_id">
				</field>

				<field label="Currency"
					col-class="col-sm-3 col-lg-3"
					:params="{type:'static'}"
					v-model="$store.contact.currency_code">
				</field>
			</template>
			<field v-if="$route.params.id == 'new' && qboIsActive"
				label="Currency"
				col-class="col-sm-3 col-lg-3"
				:params="{type:'select', options: ['CAD','USD']}"
				v-model="$store.contact.currency_code">
			</field>

			<p v-if="hasAccountLink($store.contact) && $store.contact.link_denied == 1" class="text-muted">This contact matches a {{$store.appName}} account, but you have declined to link them together. <a href="#" v-on:click.prevent="linkAccount(true)">Link accounts</a></p>

			<template slot="buttons-left">
				<button v-if="$route.params.id != 'new'" 
					type="button" 
					class="btn btn-outline-danger" 
					v-on:click="confirmDelete">

					<i class="fa fa-trash"></i> Delete Contact
				</button>
			</template>

		</vue-form>

		<modal-dialog
			:modal-visible="onHoldModal.visible"
			modal-size="modal-lg"
			:title="onHoldModal.isOnHold ? 'Place Customer On-Hold' : 'Take Customer Off-Hold'"
			:confirm-button-text="onHoldModalConfirmText"
			button-class="btn-primary"
			v-on:confirm="toggleOnHold"
			v-on:closeModal="onHoldModalClose">

			<template v-if="onHoldModal.isOnHold">
				<h3> Are you sure you would like to place {{$store.contact.name}} on-hold? </h3>
				<p> No new projects or services may be created for this customer until this setting is turned off again. </p>
			</template>

			<template v-else>
				<h3> Are you sure you would like to take {{$store.contact.name}} off hold? </h3>
				<p> Projects and services may be created for this customer again. </p>
			</template>

		</modal-dialog>

		<modal-dialog
			:modal-visible="deleteModal.visible"
			title="Delete contact"
			confirm-button-text="Delete"
			button-class="btn-outline-danger"
			v-on:confirm="deleteContact"
			v-on:closeModal="deleteModal.visible = false">
			{{deleteModal.message}}
		</modal-dialog>

		<modal-dialog
			:modal-visible="matchingContactModalVisible"
			title="Matching Contact"
			confirm-button-text="Continue with Save"
			button-class="btn-primary"
			v-on:confirm="executeSave"
			v-on:closeModal="matchingContactModalVisible = false">
			
			<p>There is already a matching contact with this name. Continue with save?</p>
			<p>Contacts with duplicate names might be difficult to tell apart</p>

		</modal-dialog>

	</div>
</template>

<script>
import ModalDialog from "@/components/ModalDialog"
import VueForm from "@/components/VueForm"
import ContactToolbar from "./ContactToolbar"
import TableList from "@/components/TableList"
import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"
import ContactMixins from "@/mixins/ContactMixins"
import ContactSubContacts from "./ContactSubContacts"
import Alert from "@/components/Alert"

import AddressManualSelector from "@/components/AddressManualSelector"

export default {

	name: 'ContactDetails',
	components: {
		ContactToolbar,
		TableList,
		FormGroup,
		Field,
		VueForm,
		ModalDialog,
		AddressManualSelector,
		ContactSubContacts,
		Alert
	},
	mixins:[ContactMixins],
	data() {
		return {
			companies: [],
			jobs: [],
			statusWorking: false,
			readonly: false,
			deleteModal: {
				visible: false,
				message: ""
			},
			companyTypes: [],
			matchingContactModalVisible: false,
			parentContact: null,
			ownerContact: null,

			onHoldModal: {
				visible: false,
				message: "",
				// Note, we keep a second copy of onhold so that changes on the page will not affect the
				// value of contact.customer_onhold until AFTER it is confirmed in the modal - only this
				// value is changed until confirmation takes place.  Set after fetched.
				isOnHold: null,
			},
		}
	},
	computed: {

		onHoldModalConfirmText() {
			if (this.onHoldModal.isOnHold)
				return "<i class='fa fa-hand-paper'></i> Place On-Hold"
			return "<i class='fa fa-thumbs-up'></i> Take Off-Hold"
		},

		linkRecord() {
			if ("UserLink" in this.$store.contact && this.$store.contact.UserLink)
				return this.$store.contact.UserLink
			else if ("CompanyLink" in this.$store.contact.CompanyLink)
				return this.$store.contact.CompanyLink

			return false
		},
		nameReadonly() {
			if (this.readonly) return true

			return this.accountLinked(this.$store.contact)
		},
		phoneReadonly() {
			if (this.readonly) return true

			let key = this.accountLinkKey(this.$store.contact)
			let contact = this.$store.contact

			if (this.accountLinked(contact) && key in contact && contact[key] && "phone" in contact[key]) {
				return contact[key].phone || contact[key].phone_mobile
			}
			return false
		},
		emailReadonly() {
			if (this.readonly) return true

			return this.accountLinked(this.$store.contact) && "email" in this.$store.contact && this.$store.contact.email
		},
		websiteReadonly() {
			if (this.readonly) return true

			return this.accountLinked(this.$store.contact) && "website" in this.$store.contact && this.$store.contact.website
		},
		addressReadonly() {
			if (this.readonly) return true

			return this.accountLinked(this.$store.contact) && this.accountLinkKey(this.$store.contact) == 'CompanyLink' //only companies will link addresses (users are private)
		},
		isCustomerReadonly() {
			if (this.readonly) return true

			return this.hasCustomerAccountLink(this.$store.contact)
		},
		typeReadonly() {
			return this.accountLinked(this.$store.contact) || this.readonly
		},
		threadSubjectRef() {
			if (this.$store.contact && "name" in this.$store.contact)
				return "Contact: "+this.$store.contact.name
			else
				return "Contact"

		},
		optionifiedCompanies() {
			return this.optionify(this.companies,"name")
		},
		companyTypeOptions() {
			return this.optionify(this.companyTypes,"type")
		},
		filteredJobs() {
			if (this.$store.contact.Job) {
				let filtered = this.$store.contact.Job.filter(job => {
					if (job.archived == 0)
						return true
				})
				return filtered
			}
			else 
				return []
		},
		showSubContacts() {
			if (window.innerWidth > 991 && this.$route.params.id != 'new')
				return true
			else return false
		}
	},
	methods: {
		setContactDefaults() {


		},
		toggleOnHold() {
			// Updates customer_onhold to match onHoldModal.isOnHold
			// Takes place after confirmation modal
			this.$store.contact.customer_onhold = this.onHoldModal.isOnHold

			// Clear reason if not on hold
			if (!this.onHoldModal.isOnHold)
				this.$store.contact.customer_onhold_reason = ""

			this.onHoldModal.visible = false
		},
		onHoldModalClose() {
			// Close modal, toggle back button (onhold value)
			this.onHoldModal.visible = false
			this.onHoldModal.isOnHold = !this.onHoldModal.isOnHold
		},
		contactNameValue(contact) {
			if (this.hasCustomerAccountLink(contact))
				return [contact.UserCustomer.first_name, contact.UserCustomer.last_name].join(' ')
			else if (this.accountLinked(contact)) {
				if (contact.CompanyLink)
					return contact.CompanyLink.company_name
				else
					return [contact.UserLink.first_name, contact.UserLink.last_name].join(' ')
			}
			else 
				return contact.name
		},
		contactPhoneValue(contact) {
			if (this.hasCustomerAccountLink(contact))
				return (contact.UserCustomer.phone_mobile && !contact.UserCustomer.phone) ?
					contact.UserCustomer.phone_mobile : contact.UserCustomer.phone

			else if (this.accountLinked(contact)) {
				if (contact.CompanyLink)
					return contact.CompanyLink.phone
				else {
					if (contact.UserLink.phone_mobile && !contact.UserLink.phone)
						return contact.UserLink.phone_mobile
					else
						return contact.UserLink.phone
				}
			}
			else 
				return contact.name
		},
		contactEmailValue(contact) {
			if (this.accountLinked(contact)) {
				if (contact.CompanyLink)
					return contact.CompanyLink.email
				else
					return contact.UserLink.email
			}
			else 
				return contact.email
		},
		contactWebsiteValue(contact) {
			if (this.accountLinked(contact)) {
				if (contact.CompanyLink)
					return contact.CompanyLink.website
				else
					return contact.UserLink.website
			}
			else
				return contact.email
		},
		contactAddressValue(contact) {

			if ("CompanyLink" in contact && contact.CompanyLink && contact.link_accepted == 1) {
				return {
					address: contact.CompanyLink.address,
					city: contact.CompanyLink.city,
					province: contact.CompanyLink.province,
					country: contact.CompanyLink.country,
					postal_code: contact.CompanyLink.postal_code
				}
			}

			return {
				address: contact.address,
				city: contact.city,
				province: contact.province,
				country: contact.country,
				postal_code: contact.postal_code
			}
		},
		contactIsCustomerValue(contact) {
			if (this.hasCustomerAccountLink(contact))
				return true
			return contact.is_customer
		},
		updateLocation(address) {
			let vm = this

			Object.keys(address).forEach((key,index) => {
				vm.$store.contact[key] = address[key]
			})
		},
		linkAccount(link) {
			let vm = this

			let payload = {
				id: this.$store.contact.id
			}

			if (link) {
				payload.link_accepted = 1
				payload.link_denied = 0 
			}
			else {
				payload.link_accepted = 0
				payload.link_denied = 1
			}

			this.postData("Contact/save",payload).then(response => {
				if (response.success) {
					vm.$store.contact.link_accepted = payload.link_accepted
					vm.$store.contact.link_denied = payload.link_denied
				}
			})
		},
		saveDetails() {
			let vm = this

			this.statusWorking = true

			//check for unique name
			let params = {
				filters: [
					["name",encodeURIComponent(this.$store.contact.name)],
					['slug !=',this.$store.contact.slug]
				],
				fields: ["id","name","slug"]
			}

			this.getJSON("Contact/get",params).then(response => {

				this.statusWorking = false

				if (response.success) {
					if (response.data.length == 0) 
						vm.executeSave()
					
					else
						vm.matchingContactModalVisible = true
				}
				else
					vm.executeSave()

			})
		},
		executeSave() {
			let vm = this

			this.statusWorking = true

			vm.matchingContactModalVisible = false

			let payload = this.cloneObj(vm.$store.contact)

			delete payload.link_accepted
			delete payload.link_denied
			delete payload.CompanyLink
			delete payload.UserLink
			delete payload.Company
			delete payload.SubContacts
			delete payload.slug
			delete payload.tenant_id

			vm.postData("Contact/save",payload,true).then(response => {

				vm.statusWorking = false

				if (response.success) {
					if (payload.is_customer == 1) {

						//clear customer list so it pulls fresh if list needs to be pulled again in app elsewhere

						vm.$store.customers = []
						vm.$store.customerOptions = []
					}

					if (vm.$route.params.id == "new") {
						vm.$router.push("/contact/"+response.slug+"/details")
						vm.$store.contact.slug = response.slug
						vm.alertSaved("Contact created!")
					}
					else
						vm.alertSaved("Saved!")
				}
			})
		},

		confirmDelete() {
			let vm = this

			this.deleteModal.visible = true
			this.deleteModal.message = "Are you sure you want to delete "+this.$store.contact.name+"?"

		},
		deleteContact() {
			let vm = this

			let payload = {
				slug: this.$route.params.id
			}

			let redirect = "/contacts"
			if (this.$store.contact.contact_id > 0) {
				let company = this.companies.find(comp => comp.id == this.$store.contact.contact_id)
				if (company)
					redirect = "/contact/"+company.slug+"/sub-contacts"
			}

			this.spinner(true)
			this.postData("Contact/delete",payload).then(function(response){
				if (response.success) {
					vm.alertSuccess(vm.$store.contact.name + " has been deleted.")

					vm.$router.push(redirect)
				}
				else 
					vm.alertFail(response.message)
				
			})
		},
		fetchParent(parentSlug) {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("Contact/find/"+parentSlug,{useLinkedData: true}).then(response => {
					if (response.success) {
						vm.$store.contact.is_company = 0
						vm.$store.contact.contact_id = response.data.id

						vm.parentContact = response.data

						vm.$forceUpdate()
					}
					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			let params = {
				filters: [["is_company",1]]
			}

			let promises = [
				this.getJSON("Contact/get",params),
				this.getJSON("BusinessType/get")
			]

			if (this.$route.params.id != 'new') 
				promises.push(this.fetchContact(this.$route.params.id,["Contact","User","Company",{model:"ContactFile", fields:[]}]))

			if ("parent_slug" in this.$route.params && this.$route.params.parent_slug)
				promises.push(this.fetchParent(this.$route.params.parent_slug))

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.companies = responses[0].data
				vm.companyTypes = responses[1].data

				vm.ownerContact = vm.companies.find(comp => comp.id == vm.$store.contact.contact_id)

				// Sync onhold value for contact (where $store.contact is set in fetchContact()
				vm.onHoldModal.isOnHold = vm.$store.contact.customer_onhold
			})
		},
	},
	created() {
		this.fetchData()

		if (this.$route.params.id == 'new') {
			this.$store.contact = new Object()
			this.setContactDefaults()
		}
	}
}
</script>

<style type="text/css">
	@media (max-width: 1200px) {
		.sub-contacts-column {
			display: none;
		}
	}
</style>